import React from "react";
import Grid from "@material-ui/core/Grid";
import { TextField } from "final-form-material-ui";
import { Field } from "react-final-form";
import { List, CrudForm, ListApi, loopback, FormApi, Filter } from "elentari";
import { exerciciosApi as api } from "../../services/Api";
import { path } from "ramda";
import ImagePicker from "../../components/ImagePicker";

const { loopbackFilters } = loopback;

const ExercicioFilter = () => (
  <Filter labels={{ find: "Buscar", clear: "Limpar" }}>
    <Grid spacing={24} container>
      <Grid item xs>
        <Field
          fullWidth
          label="Equipamento"
          component={TextField}
          name="nome"
        />
      </Grid>
    </Grid>
  </Filter>
);

export function ExerciciosList(props) {
  const listOptions = {
    defaultOrder: "nome",
    fields: {
      nome: {
        label: "Equipamento",
      },
      youtubeUrl: {
        label: "Link do Youtube",
      },
      gifUrl: {
        label: "Possui GIF",
        format: (value) => (value ? "Sim" : "Não"),
      },
    },
  };

  return (
    <ListApi
      filtersConfig={{
        nome: loopbackFilters.regexp,
      }}
      api={api}
    >
      {({ getPage, getCount, handleDelete }) => (
        <div>
          <ExercicioFilter />
          <List
            {...props}
            withPaper
            deleteItem={handleDelete}
            onClickEdit={(item) => props.history.push(`/exercicios/${item.id}`)}
            onClickNew={() => props.history.push("/exercicios/new")}
            getPage={getPage}
            getCount={getCount}
            listOptions={listOptions}
          />
        </div>
      )}
    </ListApi>
  );
}

function ExerciciosForm({ classes, ...props }) {
  const mountFileUpload = (files) => {
    const formData = new FormData();
    formData.append("image", files[0].file);
    return formData;
  };
  const submitDecorator = async ({ data, id, handleSubmit }) => {
    const result = await handleSubmit({
      id,
      data: {
        nome: data.nome ? data.nome : undefined,
        youtubeUrl: data.youtubeUrl ? data.youtubeUrl : undefined,
        gifUrl: typeof data.gifUrl === "string" ? data.gifUrl : undefined,
      },
    });

    if (result.ok) {
      if (Array.isArray(data.gifUrl)) {
        await api.uploadGif(
          path(["data", "id"], result) || id,
          mountFileUpload(data.gifUrl)
        );
      }
    }
    return result;
  };

  const validate = (values) => ({
    nome: values.nome ? undefined : "Obrigatório",
  });

  return (
    <FormApi {...props} api={api} submitDecorator={submitDecorator}>
      {({ handleSubmit, getItem }) => (
        <CrudForm
          withPaper
          validate={validate}
          history={props.history}
          submitDecorator={submitDecorator}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container direction="row" spacing={40}>
            <Grid item>
              <Field
                width={200}
                height={200}
                defaultImage={require("../../images/exercice.png")}
                component={(props) => <ImagePicker {...props} />}
                name="gifUrl"
              />
            </Grid>
            <Grid item sm={6}>
              <Grid container direction="column" spacing={16}>
                <Grid item>
                  <Field
                    fullWidth
                    autoFocus
                    component={TextField}
                    label="Equipamento"
                    name="nome"
                  />
                </Grid>
                <Grid item>
                  <Field
                    fullWidth
                    component={TextField}
                    label="Link do Youtube"
                    name="youtubeUrl"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}
export default ExerciciosForm;
